import api from './apiClient';
import type { TermsAndConditionsDocument } from '../types/terms';

/** Clave localStorage para consentimiento de cookies (Ley 21.719). */
export const COOKIE_CONSENT_STORAGE_KEY = 'mhd_cookie_consent_v1';

export type CookieConsentChoice = {
  essential: true;
  analytics: boolean;
  version: string;
  savedAt: string;
};

export type PrivacyDataRequestType =
  | 'access'
  | 'rectification'
  | 'cancellation'
  | 'opposition'
  | 'portability'
  | 'blocking';

export const ARCOP_REQUEST_TYPES = [
  { value: 'access', label: 'Acceso a mis datos' },
  { value: 'rectification', label: 'Rectificación' },
  { value: 'cancellation', label: 'Cancelación (eliminación)' },
  { value: 'opposition', label: 'Oposición al tratamiento' },
  { value: 'portability', label: 'Portabilidad' },
  { value: 'blocking', label: 'Bloqueo temporal' },
] as const;

export const privacyService = {
  getComplianceInfo: async () => {
    const { data } = await api.get('/privacy/compliance-info');
    return data;
  },

  recordCookieConsent: async (analytics: boolean, documentVersion: string) => {
    await api.post('/privacy/consent/cookies', {
      analytics,
      document_version: documentVersion,
      source: 'web',
    });
  },

  exportMyData: async () => {
    const { data } = await api.get('/privacy/my-data/export');
    return data;
  },

  createDataRequest: async (requestType: PrivacyDataRequestType, description: string) => {
    const { data } = await api.post('/privacy/data-requests', {
      request_type: requestType,
      description,
    });
    return data;
  },

  listDataRequests: async () => {
    const { data } = await api.get('/privacy/data-requests');
    return data;
  },
};

export const legalService = {
  getTermsAndConditions: async (): Promise<TermsAndConditionsDocument> => {
    const { data } = await api.get<TermsAndConditionsDocument>('/legal/terms-and-conditions');
    return data;
  },

  getLegalConsentVersions: async (): Promise<{
    terms_version: string;
    privacy_policy_version: string;
  }> => {
    const doc = await legalService.getTermsAndConditions();
    const version = doc.updated_at.trim();
    return {
      terms_version: version,
      privacy_policy_version: version,
    };
  },
};
